export const YEAR_END_PROCESS_REQUEST = 'YEAR_END_PROCESS_REQUEST';
export const YEAR_END_PROCESS_FAILURE = 'YEAR_END_PROCESS_FAILURE';
export const YEAR_END_PROCESS_SUCCESS = 'YEAR_END_PROCESS_SUCCESS';
export const SET_PROFIT_LOSS_AMOUNT = 'SET_PROFIT_LOSS_AMOUNT';
export const SAVE_YEAR_END_PROCESS = 'SAVE_YEAR_END_PROCESS';